import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { IPurchaseInvoiceItemReportGetAllParams } from "@api/stores/purchaseInvoiceItemReport/types";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  IPurchaseInvoiceItemReportGetAllParams
>("stores.purchaseInvoiceItemReport.exportPDF");

export const exportPDF = {
  ...getApis,
};
